import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { getTranslate } from 'utility/MapperTranslate'
import { confirmationAlert, showAlert } from 'utility/SweetAlert'

const InteractorTransactionReturLinesCreate = () => {
  const transactionReturLinesCreate = useCallback((body, callback) => {
    const payload = {
      ...body,
    }

    confirmationAlert({
      message: getTranslate('message.confirm_process'),
      icon: 'question',
    }).then((result) => {
      if (result === true) {
        ApiService.jsonRequest('/transaction/retur-lines/create', payload, (response) => {
          if (response.code === 7201) {
            callback(response.data)
            showAlert({
              icon: 'success',
              message: getTranslate('message.successfully_created'),
              timer: 2000,
            })
          } else {
            showAlert({
              icon: 'error',
              message: getMessage(response?.msg),
              timer: 2000,
            })
          }
        })
      }
    })
  }, [])

  return { transactionReturLinesCreate }
}

export default InteractorTransactionReturLinesCreate
